import { render } from "./OrderSummary.vue?vue&type=template&id=17548ff2&scoped=true"
import script from "./OrderSummary.vue?vue&type=script&lang=js"
export * from "./OrderSummary.vue?vue&type=script&lang=js"

import "./OrderSummary.vue?vue&type=style&index=0&id=17548ff2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17548ff2"]])

export default __exports__